export default __webpack_public_path__ + "static/media/5.46f70f20.png";